import React from 'react';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
   container: {
      width: '100%',
      height: '100%',
      display: 'table',
      verticalAlign: 'middle'
   },
   item: {
      verticalAlign: 'middle',
      display: 'table-cell'
   }
}));

function NoDataDiv({className, typographyProps}) {
   const classes = useStyles();
   return (
      <div className={clsx(classes.container, className)}>
         <Typography variant="h5" className={classes.item} align="center" {...typographyProps}>
            No existen datos para mostrar
         </Typography>
      </div>
   );
}

export default NoDataDiv;
